import { Chakra } from "@airhelp/react-ui-components";
import CircularProgress from "components/CircularProgress";
import { useTranslations } from "contexts/LocalizationContext";
import type { CompensationFeeCardContentProps } from "./CompensationFeeCardContent.d";

const { Flex, Box, Heading, Text, Stack, useMediaQuery } = Chakra;

export const CompensationFeeCardContent = ({
  title,
  receiveValue,
  feeValue,
  footnote,
  progressValue,
  variant,
}: CompensationFeeCardContentProps) => {
  const translations = useTranslations();
  const [isLessThan375] = useMediaQuery("(max-width: 374px)");
  const contentDirection = isLessThan375 ? "column-reverse" : "row";
  const contentAlignment = isLessThan375 ? "flex-start" : "center";
  const textColor = variant === "basic" ? "primary.900" : "primary.500";
  const feeFontWeight = variant === "basic" ? "normal" : "bold";

  return (
    <Flex align="center" textAlign="left" justify="space-between" direction={contentDirection}>
      <Box alignSelf={contentAlignment} mt={isLessThan375 ? 3 : 0}>
        <Stack spacing={2}>
          <Heading variant="h5" color="primary.900">
            {title}
          </Heading>
          {receiveValue && (
            <Box>
              <Text color="greyscale.600" fontSize="sm" fontWeight="medium">
                {translations("you_receive")}
              </Text>
              <Text fontSize="lg" fontWeight="medium" color={textColor}>
                {receiveValue}
              </Text>
            </Box>
          )}
          {feeValue && (
            <Box>
              <Text color="greyscale.600" fontSize="sm" fontWeight="medium">
                {translations("our_fee")}
              </Text>
              <Text fontSize="sm" color={textColor} fontWeight={feeFontWeight}>
                {feeValue}
              </Text>
            </Box>
          )}
        </Stack>
        {footnote && (
          <Text color="greyscale.500" fontSize="sm" mt={3.5} position={{ base: "unset", md: "absolute" }}>
            {footnote}
          </Text>
        )}
      </Box>
      <CircularProgress progressValue={progressValue} />
    </Flex>
  );
};
